export default __webpack_public_path__ + "static/media/batches-banner-2.7d1ed346.png";